import React, { useContext } from 'react'
import './projects.css';
import { UserContext } from '../../App';
import chat from '../../assets/projects/chat.png';
import ecommerce from '../../assets/projects/ecommerce.png';
import employee from '../../assets/projects/Employee.png';
import figma from '../../assets/projects/figma.png';
import netflix from '../../assets/projects/netflix.png';
import social from '../../assets/projects/social-app.png';
import auth from '../../assets/projects/User-auth-thumb.png';
import pp from '../../assets/projects/Pixelpolish.png';








function Projects() {
    const {theme,setTheme}=useContext(UserContext)
  return (
    <>

    <main style={{paddingTop:"5rem"}} className={theme==0?"proj-light":"proj-dark"}>
        <center className={theme==0?"name-light":"name-dark"} style={{marginBottom:"2rem"}}>Projects</center>
        <div className='proj-item-list' style={{paddingBottom:"3rem"}}>
          <section className={theme==0?'proj-item-light':'proj-item-dark'}>
                <img src={social} alt="social"/>
                <div className={theme==0?'proj-info-light':'proj-info-dark'} style={{textAlign:"center"}}>
                    <h4>Social Media Application and Private Chat</h4>
                    <h5>June 25, 2024</h5>
                    <a href="https://social-media-chat.vercel.app" target='_blank'><button style={{cursor:"pointer",border:"none",paddingLeft:"1rem",paddingRight:"1rem",paddingTop:"0.4rem",paddingBottom:"0.4rem",backgroundColor:"gold",color:'black',fontWeight:"bolder",borderRadius:"2rem",marginBottom:"2rem"}}>Demo link</button></a>
                </div>
            </section> 
            <section className={theme==0?'proj-item-light':'proj-item-dark'}>
                <img src={pp} alt="Pixel Polish"/>
                <div className={theme==0?'proj-info-light':'proj-info-dark'} style={{textAlign:"center"}}>
                    <h4>Pixel Polish , A Real time Online Photo Editor</h4>
                    <h5>sep 16, 2024</h5>
                    <a href="https://pixelpolish.vercel.app" target='_blank'><button style={{cursor:"pointer",border:"none",paddingLeft:"1rem",paddingRight:"1rem",paddingTop:"0.4rem",paddingBottom:"0.4rem",backgroundColor:"gold",color:'black',fontWeight:"bolder",borderRadius:"2rem",marginBottom:"2rem"}}>Demo link</button></a>
                </div>
            </section>
            <section className={theme==0?'proj-item-light':'proj-item-dark'}>
                <img src={ecommerce} alt="social" />
                <div className={theme==0?'proj-info-light':'proj-info-dark'} style={{textAlign:"center"}}>
                    <h4>Women Store E-Commerce</h4>
                    <h5>Jul 3, 2024</h5>
                    <a href="https://women-store.netlify.app/" target='_blank'><button style={{cursor:"pointer",border:"none",paddingLeft:"1rem",paddingRight:"1rem",paddingTop:"0.4rem",paddingBottom:"0.4rem",backgroundColor:"gold",color:'black',fontWeight:"bolder",borderRadius:"2rem",marginBottom:"2rem"}}>Demo link</button></a>
     
                </div>
            </section>
            <section className={theme==0?'proj-item-light':'proj-item-dark'}>
                <img src={employee} alt="employee" />
                <div className={theme==0?'proj-info-light':'proj-info-dark'} style={{textAlign:"center"}}>
                    <h4>Employee Management System</h4>
                    <h5>aug 2, 2024</h5>
                    <a href="https://employee-management-system-krish.netlify.app" target='_blank'><button style={{cursor:"pointer",border:"none",paddingLeft:"1rem",paddingRight:"1rem",paddingTop:"0.4rem",paddingBottom:"0.4rem",backgroundColor:"gold",color:'black',fontWeight:"bolder",borderRadius:"2rem",marginBottom:"2rem"}}>Demo link</button></a>

                </div>
            </section>
              <section className={theme==0?'proj-item-light':'proj-item-dark'}>
                <img src={netflix} alt="netflix" />
                <div className={theme==0?'proj-info-light':'proj-info-dark'} style={{textAlign:"center"}}>
                    <h4>Netflix clone idea but with Own API</h4>
                    <h5>aug 7, 2024</h5>
                    <a href="https://movie-clone-api.netlify.app" target='_blank'><button style={{cursor:"pointer",border:"none",paddingLeft:"1rem",paddingRight:"1rem",paddingTop:"0.4rem",paddingBottom:"0.4rem",backgroundColor:"gold",color:'black',fontWeight:"bolder",borderRadius:"2rem",marginBottom:"2rem"}}>Demo link</button></a>

                </div>
            </section>
            <section className={theme==0?'proj-item-light':'proj-item-dark'}>
                <img src={chat} alt="chat" />
                <div className={theme==0?'proj-info-light':'proj-info-dark'} style={{textAlign:"center"}}>
                    <h4>Real Time Chat Application</h4>
                    <h5>aug 18, 2024</h5>
                    <a href="https://real-time-chat-private.vercel.app" target='_blank'><button style={{cursor:"pointer",border:"none",paddingLeft:"1rem",paddingRight:"1rem",paddingTop:"0.4rem",paddingBottom:"0.4rem",backgroundColor:"gold",color:'black',fontWeight:"bolder",borderRadius:"2rem",marginBottom:"2rem"}}>Demo link</button></a>

                </div>
            </section>
            <section className={theme==0?'proj-item-light':'proj-item-dark'}>
                <img src={figma} alt="figma" />
                <div className={theme==0?'proj-info-light':'proj-info-dark'} style={{textAlign:"center"}}>
                    <h4>Graphical Langiding Page with figma</h4>
                    <h5>aug 22, 2024</h5>
                    <a href="https://www.figma.com/proto/lVX3UGZv9IW9pvpYbYfDIA/Krish-Project?page-id=0%3A1&node-id=4-3&viewport=-572%2C218%2C0.13&t=1iwIXVBzRE9r5leM-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4%3A3&disable-default-keyboard-nav=1" target='_blank'><button style={{cursor:"pointer",border:"none",paddingLeft:"1rem",paddingRight:"1rem",paddingTop:"0.4rem",paddingBottom:"0.4rem",backgroundColor:"gold",color:'black',fontWeight:"bolder",borderRadius:"2rem",marginBottom:"2rem"}}>Demo link</button></a>

                </div>
            </section>
            <section className={theme==0?'proj-item-light':'proj-item-dark'}>
                <img src={auth} alt="figma" />
                <div className={theme==0?'proj-info-light':'proj-info-dark'}style={{textAlign:"center"}}>
                    <h4>User Autherntication system</h4>
                    <h5>aug 29, 2024</h5>
                    <a href="https://user-auth-5v3xb4yb2-muralis-projects-24c2bb05.vercel.app/" target='_blank'><button style={{cursor:"pointer",border:"none",paddingLeft:"1rem",paddingRight:"1rem",paddingTop:"0.4rem",paddingBottom:"0.4rem",backgroundColor:"gold",color:'black',fontWeight:"bolder",borderRadius:"2rem",marginBottom:"2rem"}}>Demo link</button></a>

                </div>
            </section>
        </div>
    </main>
    </>
  )
}

export default Projects